module.exports = __webpack_public_path__ + "static/charts-6e0d48bd9318433fae60104d55b63fb3.png";